// @ts-nocheck
/**
* ATTENTION!
* @generated THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
*/

import * as Types from '../schema';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client/react';
import * as ApolloReactHooks from '@apollo/client/react';
const defaultOptions = {} as const;
export type AiChatHistoryQueryVariables = Types.Exact<{
  workspaceId: Types.Scalars['ID']['input'];
  scopeType: Types.AiChatScopeType;
  scopeDocumentCollectionId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  offset: Types.Scalars['Int']['input'];
}>;


export type AiChatHistoryQuery = { __typename?: 'Query', aiChatSessions: Array<{ __typename?: 'AiChatSession', id: string, workspaceId: string, scopeType: Types.AiChatScopeType, status: Types.AiChatSessionStatus, scopeDocumentCollectionId?: string | null, title: string, createdAt: any, updatedAt: any }> };


export const AiChatHistoryDocument = gql`
    query AiChatHistory($workspaceId: ID!, $scopeType: AiChatScopeType!, $scopeDocumentCollectionId: ID, $offset: Int!) {
  aiChatSessions(
    workspaceId: $workspaceId
    scopeType: $scopeType
    scopeDocumentCollectionId: $scopeDocumentCollectionId
    includeArchived: true
    limit: 30
    offset: $offset
  ) {
    id
    workspaceId
    scopeType
    status
    scopeDocumentCollectionId
    title
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useAiChatHistoryQuery__
 *
 * To run a query within a React component, call `useAiChatHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiChatHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiChatHistoryQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      scopeType: // value for 'scopeType'
 *      scopeDocumentCollectionId: // value for 'scopeDocumentCollectionId'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useAiChatHistoryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AiChatHistoryQuery, AiChatHistoryQueryVariables> & ({ variables: AiChatHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AiChatHistoryQuery, AiChatHistoryQueryVariables>(AiChatHistoryDocument, options);
      }
export function useAiChatHistoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AiChatHistoryQuery, AiChatHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AiChatHistoryQuery, AiChatHistoryQueryVariables>(AiChatHistoryDocument, options);
        }
// @ts-ignore
export function useAiChatHistorySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AiChatHistoryQuery, AiChatHistoryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AiChatHistoryQuery, AiChatHistoryQueryVariables>;
export function useAiChatHistorySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AiChatHistoryQuery, AiChatHistoryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AiChatHistoryQuery | undefined, AiChatHistoryQueryVariables>;
export function useAiChatHistorySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AiChatHistoryQuery, AiChatHistoryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AiChatHistoryQuery, AiChatHistoryQueryVariables>(AiChatHistoryDocument, options);
        }
export type AiChatHistoryQueryHookResult = ReturnType<typeof useAiChatHistoryQuery>;
export type AiChatHistoryLazyQueryHookResult = ReturnType<typeof useAiChatHistoryLazyQuery>;
export type AiChatHistorySuspenseQueryHookResult = ReturnType<typeof useAiChatHistorySuspenseQuery>;
export type AiChatHistoryQueryResult = ApolloReactCommon.QueryResult<AiChatHistoryQuery, AiChatHistoryQueryVariables>;